<template>
  <ul role="list" class="space-y-3 text-sm/6 text-gray-600">
    <li
      v-for="item in items"
      :key="item"
      class="flex gap-x-3"
    >
      <icon
        name="ph:check-fat-duotone"
        aria-hidden="true"
        class="h-6 w-5 flex-none text-brand-700"
      />

      {{ item }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { CheckListProps } from 'types/section'

const { items } = defineProps<CheckListProps>()
</script>
